/** When the page last reloaded itself for a missing chunk. */
const RELOADED_AT = 'reloaded-for-new-build-at';
const MIN_GAP_MS = 60_000;

/**
 * After a deploy, a page left open still points at the previous build's code
 * chunks, which are gone, so opening a screen it hasn't loaded yet fails with
 * "Failed to fetch dynamically imported module". Vite reports that as
 * `vite:preloadError`, and a reload picks up the new build.
 *
 * At most once a minute: a chunk missing for another reason shows its error
 * rather than reloading in a loop. Without storage to remember the reload, it
 * never reloads, for the same reason.
 */
export function reloadForNewBuild(
  event: Event,
  storage: Pick<Storage, 'getItem' | 'setItem'>,
  reload: () => void,
  now: number = Date.now()
): void {
  try {
    if (now - Number(storage.getItem(RELOADED_AT) ?? 0) < MIN_GAP_MS) return;
    storage.setItem(RELOADED_AT, String(now));
  } catch {
    return;
  }
  event.preventDefault();
  reload();
}
